import { createSlice } from "@reduxjs/toolkit";
import { setToken as _setToken, getToken, removeToken, } from "@/utils";
import { loginAPI, getProfileAPI } from "@/apis/user";
import { message } from "antd";

const userStore = createSlice({
    name: "user",
    //数据状态
    initialState: {
        token: getToken() || '',
        userInfo: {}
    },
    //同步修改方法
    reducers: {
        setToken(state, action) {
            state.token = action.payload
            //localStorage
            _setToken(action.payload)
        },
        setUserInfo(state, action) {
            state.userInfo = action.payload
        },
        clearUserInfo(state, action) {
            state.token = {}
            state.userInfo = {}
            removeToken()
        }
    }
})

// 解构出actionCreator
const { setToken, setUserInfo, clearUserInfo } = userStore.actions

// 获取reducer函数
const userReducer = userStore.reducer

//异步方法，完成登录获取token
const fetchLogin = (loginForm) => {
    return async (dispatch) => {
        //1. 发送异步请求

        //测试url
        try {
            const res = await loginAPI(loginForm)
            if (res.code === 0) {
                //2. 提交同步action进行token的存入
                dispatch(setToken(res.data))
                message.success(
                    <>
                        登录成功！<br />
                        Login successful!
                    </>
                )
            } else if (res.code === 400) {
                message.error(
                    <>
                        账号或密码错误！请重新输入！<br />
                        Incorrect account or password! Please re-enter!
                    </>
                )
            } else if (res.code === 405) {
                message.error(
                    <>
                        参数错误，请重新输入！<br />
                        Parameter error, please re-enter!
                    </>
                )
            } else if (res.code === 407) {
                message.error(
                    <>
                        用户不存在！请重新输入！<br />
                        User does not exist! Please re-enter!
                    </>
                )
            } else if (res.code === 500) {
                message.error(
                    <>
                        服务器内部错误，请稍后再试！<br />
                        Internal server error, please try again later!
                    </>
                )
            } else {
                message.error(
                    <>
                        用户审核中，请联系管理员！<br />
                        User verification in progress, please contact the administrator!
                    </>
                )
            }
        } catch (error) {
            console.error("Login error:", error);
            message.error(
                <>
                    登录失败，请稍后再试！<br />
                    Login failed, please try again later!
                </>
            )
        }
    }
}

//异步方法，获取个人用户信息
const fetchUserInfo = () => {
    return async (dispatch) => {
        //测试url
        try {
            const res = await getProfileAPI()
            dispatch(setUserInfo(res.data))
        } catch (error) {
            console.error("获取用户信息失败:", error);
            message.error(
                <>
                    获取用户信息失败，请重新登录！<br />
                    Failed to get user information, please login again!
                </>
            )
        }
    }
}

export { fetchLogin, fetchUserInfo, clearUserInfo, setToken }

export default userReducer